/**
 * Which chapters of a book this browser has studied to the end — the end state's "Book so
 * far". A per-viewer convenience, so browser storage: progress across devices is Phase 3
 * (API_CHANGES 12). Storage can be absent or throw (private windows); then it is this visit's.
 */
const key = (bookId: string) => `carrel:studied:${bookId}`;
const memory = new Map<string, number[]>();

export function studiedChapters(bookId: string): number[] {
  try {
    const raw = localStorage.getItem(key(bookId));
    const list: unknown = raw ? JSON.parse(raw) : [];
    if (Array.isArray(list)) return list.filter((n): n is number => typeof n === "number");
  } catch {
    // fall through to this visit's record
  }
  return memory.get(bookId) ?? [];
}

export function markStudied(bookId: string, chapter: number): number[] {
  const list = [...new Set([...studiedChapters(bookId), chapter])].sort((a, b) => a - b);
  memory.set(bookId, list);
  try {
    localStorage.setItem(key(bookId), JSON.stringify(list));
  } catch {
    // kept in memory for this visit
  }
  return list;
}
